<template>
  <v-card class="card mx-auto pa-6" outlined>
    <v-list-item three-line class="pa-0">
      <v-list-item-content class="pa-0">
        <v-card-text color="secondary" class="card__title pa-0">
          {{ title }}
        </v-card-text>
        <v-card-text class="card__description pa-0 mt-2">
          {{ description }}
        </v-card-text>
        <v-card-actions class="card__action d-flex flex-row-reverse pa-0">
          <button-download
            :file="file"
            :disableDownloadIcon="true"
            @on-download="handleClickDownload"
          />
        </v-card-actions>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { SEGMENT_EVENTS } from '../../constants';
import ButtonDownload from '../buttons/button-download-1.vue';

export default {
  props: ['tag', 'id', 'title', 'description', 'file'],
  components: {
    ButtonDownload,
  },
  methods: {
    handleClickDownload() {
      window.analytics.track(SEGMENT_EVENTS.DOWNLOAD_TECHNICAL_GUIDE, {
        contentTitle: this.title,
        contentId: this.id,
        contentType: 'Technical Guides'
      });
    },
  },
};
</script>

<style scoped>
.card {
  border: 0;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  height: 100%;
  cursor: text;
}
.card .card__title {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.1px;
  height: 36px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card .card__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  height: 51px;
  color: #7b7d7a;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: text;
}
.card .card__btn {
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.1px;
  text-transform: capitalize;
}
.card .card__action {
  margin-top: 10px;
}
</style>
